<template>
    <div :id="id" class="obx_bg">
        <a-row class="list" type="flex" align="middle">

            <!-- 总分 -->
            <a-col class="mg_r" >
                <div class="yuan_1" :class="type == 11 ? '' : 'bg_c'">
                    {{PdftStore.fromData.questionnaireInfo?.score}}
                </div>
                <!-- <a-progress type="circle" :width="170" strokeColor="#00baf4" :percent="PdftStore.fromData.questionnaireInfo?.score">
                    <template #format="percent">
                        <span style="color:#013C89;">{{ percent }}</span>
                    </template>
                </a-progress> -->
            </a-col>

            <!-- 运营排放 -->
            <a-col class="list_r" :class="type == 1 ? 'bg' : type == 11 ? '' : 'bg_t'">
                <div class="yuan">
                    {{PdftStore.fromData.spaceEmissionOperational?.updateScore}}
                </div>
                <!-- <a-progress type="circle" :width="70" strokeColor="#00baf4" :percent="PdftStore.fromData.spaceEmissionOperational?.updateScore">
                    <template #format="percent">
                        <span style="color:#00BAF4">{{ percent }}</span>
                    </template>
                </a-progress> -->
                <div :class="type == 1 ? 'txtc' : 'list_b'">
                    <div class="flex">
                        <div class="t">Operational Emissions</div>
                    </div>
                    <div class="flex mg_top_list">
                        <div class="t_a">Weight {{PdftStore.fromData.spaceEmissionOperational?.weight}}%</div>
                    </div>
                </div>
            </a-col>

            <!-- 产业链排放 -->
            <a-col class="list_r" :class="type == 2 ? 'bg' : type == 11 ? '' : 'bg_t'">
                <div class="yuan">
                    {{PdftStore.fromData.spaceEmissionIndustrialChain?.updateScore}}
                </div>
                <!-- <a-progress type="circle" :width="70" strokeColor="#00baf4" :percent="PdftStore.fromData.spaceEmissionIndustrialChain?.updateScore">
                    <template #format="percent">
                        <span style="color:#00BAF4;">{{ percent }}</span>
                    </template>
                </a-progress> -->
                <div :class="type == 2 ? 'txtc' : 'list_b'">
                    <div class="flex">
                        <div class="t">Industry Chain Emissions</div>
                    </div>
                    <div class="flex mg_top_list">
                        <div class="t_a">Weight {{PdftStore.fromData.spaceEmissionIndustrialChain?.weight}}%</div>
                    </div>
                </div>
            </a-col>

            <!-- 直接减排贡献 -->
            <a-col class="list_r" :class="type == 3 ? 'bg' : type == 11 ? '' : 'bg_t'">
                <div class="yuan">
                    {{PdftStore.fromData.spaceEmissionDirectReduction?.updateScore}}
                </div>
                <!-- <a-progress type="circle" :width="70" strokeColor="#00baf4" :percent="PdftStore.fromData.spaceEmissionDirectReduction?.updateScore">
                    <template #format="percent">
                        <span style="color:#00BAF4;">{{ percent }}</span>
                    </template>
                </a-progress> -->
                <div :class="type == 3 ? 'txtc' : 'list_b'">
                    <div class="flex">
                        <div class="t">Contribution to Direct Emission Reduction</div>
                    </div>
                    <div class="flex mg_top_list">
                        <div class="t_a">Weight {{PdftStore.fromData.spaceEmissionDirectReduction?.weight}}%</div>
                    </div>
                </div>
            </a-col>

            <!-- 间接减排贡献 -->
            <a-col class="list_r" :class="type == 4 ? 'bg' : type == 11 ? '' : 'bg_t'">
                <div class="yuan">
                    {{PdftStore.fromData.spaceEmissionIndirectReduction?.updateScore}}
                </div>
                <!-- <a-progress type="circle" :width="70" strokeColor="#00baf4" :percent="PdftStore.fromData.spaceEmissionIndirectReduction?.updateScore">
                    <template #format="percent">
                        <span style="color:#00BAF4;">{{ percent }}</span>
                    </template>
                </a-progress> -->
                <div :class="type == 4 ? 'txtc' : 'list_b'">
                    <div class="flex">
                        <div class="t">Contribution to Indirect Emission Reduction </div>
                    </div>
                    <div class="flex mg_top_list">
                        <div class="t_a">Weight {{PdftStore.fromData.spaceEmissionIndirectReduction?.weight}}%</div>
                    </div>
                </div>
            </a-col>

            <!-- 零碳运营 -->
            <a-col class="list_r" :class="type == 5 ? 'bg' : type == 11 ? '' : 'bg_t'">
                <div class="yuan">
                    {{PdftStore.fromData.spaceEmissionZeroOperation?.updateScore}}
                </div>
                <!-- <a-progress type="circle" :width="70" strokeColor="#00baf4" :percent="PdftStore.fromData.spaceEmissionZeroOperation?.updateScore">
                    <template #format="percent">
                        <span style="color:#00BAF4;">{{ percent }}</span>
                    </template>
                </a-progress> -->
                <div :class="type == 5 ? 'txtc' : 'list_b'">
                    <div class="flex">
                        <div class="t">Zero-Carbon Operation </div>
                    </div>
                    <div class="flex mg_top_list">
                        <div class="t_a">Weight {{PdftStore.fromData.spaceEmissionZeroOperation?.weight}}%</div>
                    </div>
                </div>
            </a-col>

            <!-- 绿色供应链 -->
            <a-col class="list_r" :class="type == 6 ? 'bg' : type == 11 ? '' : 'bg_t'">
                <div class="yuan">
                    {{PdftStore.fromData.spaceEmissionGreenSupply?.updateScore}}
                </div>
                <!-- <a-progress type="circle" :width="70" strokeColor="#00baf4" :percent="PdftStore.fromData.spaceEmissionGreenSupply?.updateScore">
                    <template #format="percent">
                        <span style="color:#00BAF4;">{{ percent }}</span>
                    </template>
                </a-progress> -->
                <div :class="type == 6 ? 'txtc' : 'list_b'">
                    <div class="flex">
                        <div class="t">Green Supply Chain </div>
                    </div>
                    <div class="flex mg_top_list">
                        <div class="t_a">Weight {{PdftStore.fromData.spaceEmissionGreenSupply?.weight}}%</div>
                    </div>
                </div>
            </a-col>

            <!-- 承诺与披露 -->
            <a-col class="list_r" :class="type == 7 ? 'bg' : type == 11 ? '' : 'bg_t'">
                <div class="yuan">
                    {{PdftStore.fromData.spaceEmissionPromise?.updateScore}}
                </div>
                <!-- <a-progress type="circle" :width="70" strokeColor="#00baf4" :percent="PdftStore.fromData.spaceEmissionPromise?.updateScore">
                    <template #format="percent">
                        <span style="color:#00BAF4;">{{ percent }}</span>
                    </template>
                </a-progress> -->
                <div :class="type == 7 ? 'txtc' : 'list_b'">
                    <div class="flex">
                        <div class="t">Pledges And Disclosure </div>
                    </div>
                    <div class="flex mg_top_list">
                        <div class="t_a">Weight {{PdftStore.fromData.spaceEmissionPromise?.weight}}%</div>
                    </div>
                </div>
            </a-col>

            <!-- 零碳投资 -->
            <a-col class="list_r" :class="type == 8 ? 'bg' : type == 11 ? '' : 'bg_t'">
                <div class="yuan">
                    {{PdftStore.fromData.spaceEmissionZeroInvestment?.updateScore}}
                </div>
                <!-- <a-progress type="circle" :width="70" strokeColor="#00baf4" :percent="PdftStore.fromData.spaceEmissionZeroInvestment?.updateScore">
                    <template #format="percent">
                        <span style="color:#00BAF4;">{{ percent }}</span>
                    </template>
                </a-progress> -->
                <div :class="type == 8 ? 'txtc' : 'list_b'">
                    <div class="flex">
                        <div class="t">Zero-Carbon Investment</div>
                    </div>
                    <div class="flex mg_top_list">
                        <div class="t_a">Weight {{PdftStore.fromData.spaceEmissionZeroInvestment?.weight}}%</div>
                    </div>
                </div>
            </a-col>

        </a-row>
    </div>
</template>

<script>
import { reactive, toRefs, onBeforeMount, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import { usePdftStore } from '@/store/pdf'
import { formatDateTimeYYmm, formatDateTimeYY } from '@/utils/date'
export default {
    name: 'list',
    props:{
        type:{
            type:Number,
            default:() => null
        },
        id:{
            type:String,
            default:() => null
        }
    },
    setup(props) {
        const data = reactive({
            type:props.type,
            id:props.id
        })
        //引入数据管理库
        const PdftStore = usePdftStore()
        const formatDateTimeYYmms = (str) => {
            return formatDateTimeYYmm(str)
        }
        const formatDateTimeYYs = (str) => {
            return formatDateTimeYY(str)
        }
        onBeforeMount(() => {})
        onMounted(() => {})
        return {
            PdftStore,
            formatDateTimeYYmms,
            formatDateTimeYYs,
            ...toRefs(data),
        }
    },
}

</script>
<style scoped lang='less'>
.list{
    width: 100%;
    height: 250px;
    border-top: 1px solid #C5C5C6;
    border-bottom: 1px solid #C5C5C6;
    background: transparent;
    .mg_r{
        margin-right: 15px;
        background: transparent;
    }
    .list_r{
        width: 115px;
        margin: 0 9px;
        height: 100%;
        padding: 40px 0;
        text-align: center;
        background: transparent;
        .list_b{
            padding-top: 12px;
            margin-top: 10px;
            border-top: 2px solid #322523;
            .mg_top_list{
                padding-top: 12px;
            }
            .flex{
                display: flex;
                justify-content: center;
                align-items: center;
                .t{
                    font-size: 12px;
                    font-weight: 400;
                    color: #333333;
                    line-height: 17px;
                }
                .t_m{
                    font-size: 24px;
                    font-weight: 500;
                    color: #013C89;
                    line-height: 17px;
                }
                .t_a{
                    font-size: 14px;
                    font-weight: 400;
                    color: #333333;
                    line-height: 17px;
                }
                .s_j{
                    margin-right: 3px;
                    width:0;
                    height:0;
                    border-left:5.5px solid transparent;
                    border-right:5.5px solid transparent;
                    border-bottom:11px solid #013C89;
                }
                
            }
        }
    }
    .bg{
        background: #013C89;
        .yuan{
            border-color: #2fbf94 !important;
            color: #FFFFFF !important;
        }
    }
    .txtc{
        padding-top: 12px;
        margin-top: 10px;
        .t{
            font-size: 14px;
            font-weight: 400;
            line-height: 17px;
            color: #FFFFFF;
        }
        .mg_top_list{
                padding-top: 12px;
            }
        .t_a{
            font-size: 14px;
            font-weight: 400;
            line-height: 17px;
            color: #FFFFFF;
        }
    }
}
.obx_bg{
    background: transparent;
}
.yuan_1{
    width: 170px;
    height: 170px;
    border-radius: 50%;
    border: 10px solid #00baf4;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 72px;
    color: #013C89;
}
.yuan{
    width: 70px;
    height: 70px;
    border-radius: 50%;
    border: 5px solid #00baf4;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 32px;
    color: #00BAF4;
    margin: 0 auto;
}
.bg_c{
    border-color: #868686 !important;
    color: #868686 !important;
}
.bg_t{
    .yuan{
        border-color: #868686 !important;
        color: #868686 !important;
    }
    
}
</style>